import React from "react";

interface WhyLMItemProps {
    imageUrl: string;
    title: string;
    description: string;
}

const WhyLMItem: React.FC<WhyLMItemProps> = ({ imageUrl, title, description }) => {
    return (
        <div className="flex flex-col items-center text-center gap-2 max-w-xs mx-auto">
            <img src={imageUrl} alt={title} className="w-12 h-12 object-contain" />
            <h3 className="text-sm font-semibold text-gray-800 font-poppins">{title}</h3>
            <p className="text-xs text-gray-600 min-h-[60px] font-poppins">{description}</p>
        </div>
    );
};

export default WhyLMItem;